import { useLocation } from 'react-router-dom';
import { isCarvanaNativeApp, isAndroidNativeWebview } from '|/helpers/is-native-app';
import { MobileWebviewEvents } from '|/helpers/mobile-webview-events/mobile-webview-events';
import sendNativeEvent from '|/helpers/send-native-event';
import useAnalyticsContext from '|/hooks/use-analytics-context';

interface UseSupportContactClickArgs {
  onClick: () => void;
  onClose?: () => void;
}

/**
 * Click semantics shared by both Support & Contact forms. In a native webview the request hands
 * off to the native support screen and `onClick` never runs, so the analytics event fires here
 * rather than in the caller — otherwise the native path would go uncounted.
 */
const useSupportContactClick = ({ onClick, onClose }: UseSupportContactClickArgs) => {
  const { trackEvent } = useAnalyticsContext();
  const location = useLocation();

  return () => {
    trackEvent('pp_header_support_contact_clicked');

    if (isCarvanaNativeApp()) {
      const eventName = isAndroidNativeWebview()
        ? MobileWebviewEvents.OPEN_SEBASTIAN
        : MobileWebviewEvents.OPEN_SUPPORT;

      onClose?.();
      sendNativeEvent({
        event: eventName,
        payload: { currentStep: location.pathname },
        source: 'purchase'
      });

      return;
    }

    onClick();
  };
};

export default useSupportContactClick;
